import { Converesation } from "../../models/conversation";
import { getAsync, postAsync, putAsync } from "./api-base";
import { Feedback } from "../../pages/feedback/feedback";

type IDownloadAttatchment = {
	fileName: string;
	file: string;
};

export const getMessages = async (
	time: Date | undefined,
	systems: string[],
	searchString: string,
	onlyUnreadMessages: boolean,
) => {
	const params = {
		time: time?.toISOString(),
		systems: systems,
		searchString,
		onlyUnreadMessages,
	};

	const res = await getAsync<Converesation[]>(`mypagesmessages/messages`, "", params);

	return res.map((c) => new Converesation(c));
};

export const sendMessage = async (text: string, batchId: Guid, system: string) => {
	return await postAsync<void, null>("mypagesmessages/sendMessage", null, system, { text, batchId });
};

export const downloadAttachment = async (uniqueId: string, fileName: string, system: string) => {
	return getAsync<IDownloadAttatchment>(
		`me/downloadMessageAttachment/${encodeURIComponent(uniqueId)}&${encodeURIComponent(fileName)}`,
		system,
		{},
	);
};

export const setMessageAsRead = async (batchId: string, system: string) => {
	return putAsync<void, string>(`mypagesmessages/setMessageAsRead`, undefined, system, { batchId });
};

export const getUnreadMessages = async (systems: string[]) => {
	const url = `mypagesmessages/unreadMessageCount`;
	try {
		return await getAsync<number>(url, "", { systems });
	} catch {
		return undefined;
	}
};

export const sendFeedback = async (feedback: Feedback) => {
	const url = "mypages/sendFeedback";
	return await postAsync(url, feedback);
};
